import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device } from '@helpers/media';
import styled from 'styled-components';
import DesktopNavigationDropdownLinkStyles from '../DesktopNavigationDropdownLink/DesktopNavigationDropdownLink.styles';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 33px 22px;
`;

const SectionTitle = styled.strong`
  display: block;
  width: 100%;
  ${fonts.helvetica['83-heavy-extended']}
  font-size: ${fluid(26, 32, Device.DesktopSmall, Device.ActualDesktop)};
  line-height: 1em;
  text-transform: uppercase;
  text-align: center;

  sup {
    font-size: 0.6em;
    vertical-align: super;
  }
`;

const Column = styled.ul`
  position: relative;
  flex: 1 0 calc(var(--columnWidth, '16.666%') - 20px);
  padding: ${fluid(8, 16, Device.DesktopSmall, Device.ActualDesktop)} 0;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: -10px;
    width: 2px;
    height: 100%;
    background-color: ${brand.grey[97]};
  }

  &:last-child::after {
    display: none;
  }

  ${DesktopNavigationDropdownLinkStyles.NavLink} {
    display: inline-flex;
    ${fonts.helvetica['73-bold-extended']}
    font-size: ${fluid(12, 14, Device.DesktopSmall, Device.ActualDesktop)};
    line-height: 1.25em;
    padding: 9px 0;

    &:hover {
      color: ${brand.red.base};
      text-decoration: underline;
      text-underline-offset: 2px;
    }
  }
`;

const SystemLogo = styled.div`
  display: flex;
  place-items: center;
  place-content: center;
  height: ${fluid(69 * 0.7, 69, Device.DesktopSmall, Device.ActualDesktop)};
  margin-bottom: 25px;

  svg {
    height: var(--systemLogoHeight);
  }
`;

const Title = styled.strong`
  display: block;
  width: 100%;
  ${fonts.helvetica['93-black-extended']}
  font-size: ${fluid(14, 18, Device.DesktopSmall, Device.ActualDesktop)};
  line-height: 1em;
  text-transform: uppercase;
  min-height: 54px;
  max-width: 170px;
  margin: 0 auto ${fluid(4, 20, Device.DesktopSmall, Device.ActualDesktop)};

  [data-culture]:not([data-culture='en-GB'], [data-culture='en-TT']) & {
    max-width: 230px;
    word-break: break-word;
  }
`;

const SystemDropdownStyles = {
  Container,
  SectionTitle,
  Column,
  SystemLogo,
  Title,
};

export default SystemDropdownStyles;
